// Import dependencies
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';

// Import providers
import { useAuth } from './contexts/Auth';

// Import services
import { mouseTracker } from './utils/mouseTracker';

// Import pages
import Home from './pages/Home';
import Login from './pages/Login';
import Construction from './pages/construction';
import Tutorials from './pages/Tutorials'
import ForgotPassword from './pages/ForgotPassword';
import VerifyResetCode from './pages/VerifyResetCode';
import ResetPassword from './pages/ResetPassword';
import Instructor from './pages/Instructor';
import ViewWorkspace from './pages/ViewWorkspace';
import SessionWorkspace from './pages/SessionWorkspace';
import TestLogin from './pages/TestLogin';

// Main App component
function App() {
  // Contexts
  const { userAuthenticated, authLoading } = useAuth();

  // Start mouse tracking when app mounts
  useEffect(() => {
    // Only start tracking if user is authenticated
    if (userAuthenticated) {
      mouseTracker.start();
    } else {
      mouseTracker.stop();
    }
    
    // Cleanup on unmount
    return () => {
      mouseTracker.stop();
    };
  }, [userAuthenticated]);

  // Show loading state while checking authentication
  if (authLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-grey-lighter">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-dark"></div>
          <p className="mt-4 text-grey-dark">Loading...</p>
        </div>
      </div>
    );
  }

  //  Visible component
  return (
    <Router>
      <div id="app-container" className="bg-grey-lighter font-roboto-regular">
            <Routes>
                <Route path='/' element={userAuthenticated ? <Navigate to="/home" /> : <Navigate to="/login" />} />
                <Route path='/home' element={<Home />} />
                <Route path='/login' element={<TestLogin />} />
                <Route path='/forgot-password' element={<ForgotPassword />} />
                <Route path='/verify-reset-code' element={<VerifyResetCode />} />
                <Route path='/reset-password' element={<ResetPassword />} />
                <Route path='/construction' element={<Construction />} />
                <Route path='/tutorials' element={<Tutorials />}/>
                <Route path='/instructor' element={<Instructor />}/>
                <Route path='/workspace/:studentId' element={<ViewWorkspace />}/>
                <Route path='/session/:shareToken' element={<SessionWorkspace />}/>
                <Route path='/testlogin' element={<Login />}/>
            </Routes>
      </div>
    </Router>
  );
}

export default App;
